import { FluxoCaixaForm } from './FluxoCaixaForm';
import { FluxoCaixaModalShell } from './FluxoCaixaModalShell';
import { FluxoCaixaFormData } from '../types/fluxoCaixa';

interface FluxoCaixaCreateModalProps {
  visible: boolean;
  loading?: boolean;
  formKey?: number;
  onSubmit: (data: FluxoCaixaFormData) => Promise<void>;
  onCancel: () => void;
}

export function FluxoCaixaCreateModal({
  visible,
  loading = false,
  formKey = 0,
  onSubmit,
  onCancel,
}: FluxoCaixaCreateModalProps) {
  const handleSubmit = async (data: FluxoCaixaFormData) => {
    await onSubmit(data);
    onCancel();
  };

  return (
    <FluxoCaixaModalShell
      open={visible}
      onCancel={onCancel}
      eyebrow="Criar Lançamento"
      title="Novo lançamento no fluxo de caixa"
    >
      <FluxoCaixaForm
        onSubmit={handleSubmit}
        loading={loading}
        formKey={formKey}
        onCancel={onCancel}
        submitLabel={loading ? 'Lançando...' : 'Lançar'}
        variant="modal"
      />
    </FluxoCaixaModalShell>
  );
}
